import {
  CollaborativeDocumentFragment,
  GenerateCollaborativeDocumentMutation,
  GenerateCollaborativeDocumentMutationVariables,
  useGenerateCollaborativeDocumentMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useGenerateCollaborativeDocument = withStandardMutationHook<
  GenerateCollaborativeDocumentMutation,
  CollaborativeDocumentFragment,
  GenerateCollaborativeDocumentMutationVariables,
  'generateCollaborativeDocument',
  [string]
>(
  useGenerateCollaborativeDocumentMutation,
  'generateCollaborativeDocument',
  (name: string) => ({ name }),
);
